import {
  Injectable
} from '@angular/core';

import {
  CanActivate,
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot
} from '@angular/router';


import {
  AuthService
} from '../auth';

@Injectable()
export class DistributorGuard implements CanActivate {

  constructor(private auth: AuthService, private router: Router) {
  }

  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {

    if (!this.auth.isAuthenticated()) {
      this.auth.logout();
      this.router.navigate(['auth', 'login']);
      return false;
    }

    return this.auth.hasRole('administrator') || (this.auth.hasRole("distributor") &&
      (this.auth.hasRole('manager') || this.auth.hasRole('associate')));
  }
}
